import { TitleActionType as ActionType } from 'src/stores/action-types/titleActionType'
import { TitleAction as Action } from 'src/stores/actions/titleActions'
import { ReactElement } from 'react'

export type TitleState = {
    title?: string
    showBackButton?: boolean
    actions?: ReactElement | ReactElement[]
}

const initialTitle: TitleState = {
    title: '',
    showBackButton: false,
    actions: undefined
}

export const titleReducer = (state: TitleState = initialTitle, action: Action): TitleState => {
    switch (action.type) {
        case ActionType.SET_TITLE:
            return {
                ...state,
                title: action.payload?.title as string,
                showBackButton: action.payload?.showBackButton as boolean,
                actions: action.payload?.actions as ReactElement | ReactElement[] | undefined
            }

        default:
            return { ...state }
    }
}
